import { render } from "./InfoCountList.vue?vue&type=template&id=85bc6af6&scoped=true"
import script from "./InfoCountList.vue?vue&type=script&lang=js"
export * from "./InfoCountList.vue?vue&type=script&lang=js"

import "./InfoCountList.vue?vue&type=style&index=0&id=85bc6af6&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85bc6af6"]])

export default __exports__